<div class="t-edit-link">
    <ng-container *ngIf="edit; else view">
        <label class="t-label">
            <div class="t-label-properties">
                <ng-container *ngIf="anchorMode; else fullOptions">Edit anchor</ng-container>
                <ng-template #fullOptions>
                    <span *ngIf="prefixIsHashMode; else urlTitle">Link to anchor</span>
                    <ng-template #urlTitle>
                        <span>URL</span>
                    </ng-template>
                </ng-template>
            </div>
            <div class="t-url">
                <div class="t-prefix">{{ prefix }}</div>
                <tui-input-inline
                    tuiAutoFocus
                    class="t-input"
                    [class.t-input_filled]="hasUrl"
                    [(ngModel)]="url"
                    (input)="onChange($any($event.target)?.value)"
                    (keydown.prevent.enter)="onSave()"
                    (keydown.backspace)="onBackspace()"
                >
                    <ng-container *ngIf="texts$ | async as text">
                        {{ prefixIsHashMode ? text.anchorExample : text.urlExample }}
                    </ng-container>
                </tui-input-inline>
            </div>
        </label>
        <tui-svg
            src="tuiIconCloseLarge"
            class="t-cleaner"
            [class.t-cleaner_hidden]="!hasUrl"
            (click)="onClear()"
        ></tui-svg>
        <button
            tuiIconButton
            type="button"
            size="s"
            title="Insert link"
            icon="tuiIconCheckCircleLarge"
            shape="rounded"
            appearance="icon"
            class="t-button"
            (click)="onSave()"
        ></button>
    </ng-container>
    <ng-template #view>
        <a
            tuiLink
            target="_blank"
            iconAlign="left"
            class="t-link"
            [href]="href"
            [icon]="prefixIsHashMode ? 'tuiIconHash' : 'tuiIconExternalLink'"
        >
            {{ url | tuiShortUrl }}
        </a>
        <button
            tuiIconButton
            type="button"
            size="s"
            title="Change link"
            icon="tuiIconEdit2Large"
            shape="rounded"
            appearance="icon"
            class="t-button t-edit-button"
            (click)="onEdit()"
        ></button>
        <button
            tuiIconButton
            type="button"
            size="s"
            title="Remove link"
            icon="tuiIconUnlinkLarge"
            shape="rounded"
            appearance="icon"
            class="t-button"
            (click)="onRemove()"
        ></button>
    </ng-template>
</div>

<ng-container *ngIf="showAnchorsList">
    <hr class="t-hr" />
    <tui-scrollbar>
        <div class="t-anchor-list">
            <button
                *ngFor="let id of anchorIds | tuiFilterAnchors : prefix : url"
                type="button"
                class="t-anchor"
                (click)="setAnchor(id)"
            >
                #{{ id }}
            </button>
        </div>
    </tui-scrollbar>
</ng-container>
